import axios from '../../../../utils/request';
function SOURCE_GET_LIST(params) {
    return axios.post("/statistics/AVisitors/sourceAll",{ ...params } )
}
export default {
    SOURCE_GET_LIST,


};
